<template>
	<div class="school-loans">
		<ViewLoan />

		<div class="row">
			<div class="col-12 col-lg-6" v-if="my_loans.length > 0">
				<div class="title-content clearfix">
					<div class="title f-l">My Loans</div>
				</div>
				<div class="scroll-content">
					<scrollbar>
						<div class="row">
							<div
								class="col-md-6 col-lg-12"
								v-for="(loan, i) in my_loans"
								:key="i"
								@click="viewLoan(loan)"
							>
								<div class="invoice-box">
									<div class="date-box clearfix">
										<div class="txt f-l">Request Date:</div>
										<div class="date f-l">
											{{
												moment(
													loan
														.loan_application_details
														.created_date,
												).format('Do MMM YYYY hh:mmA')
											}}
										</div>
										<div class="status f-r">
											{{ loan.loan_status }}
										</div>
									</div>
									<div class="clearfix">
										<div class="name-box f-l">
											<div class="txt tx-uppercase">
												ID:
												{{
													loan.loan_application_system_ref
												}}
											</div>
											<div class="bolder-text">
												Product:
												{{
													loan.loan_product_details
														.loan_product_name
												}}
											</div>
											<div class="date small">
												Due Date:
												{{
													moment(
														loan.loan_due.due_date,
													).format(
														'Do MMM YYYY hh:mmA',
													)
												}}
											</div>
										</div>
										<div class="price-box f-r">
											<div class="txt small">
												Loan Due:
											</div>
											<div class="price tx-blue">
												{{ loan.currency || 'KES' }}
												{{
													utils.numberWithCommas(
														loan.loan_due.total_due
															.toString()
															.split('.')[0],
													)
												}}
												<span
													class="point"
													v-if="
														loan.loan_due.total_due
															.toString()
															.includes('.')
													"
													>.{{
														loan.loan_due.total_due
															.toString()
															.split('.')[1]
															.slice(0, 2)
													}}</span
												>
											</div>
											<div class="txt">Total</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</scrollbar>
				</div>
			</div>
			<div
				class="col-12 col-lg-6"
				v-if="!my_loans || my_loans.length === 0"
			>
				<div class="white-content">
					<div class="title">No Loans Found.</div>
				</div>
			</div>
			<div class="col-12 col-lg-5">
				<Advert />
			</div>
		</div>
	</div>
</template>

<script>
import my_loan from '../rsc/stores/my-loans.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	async beforeCreate() {
		Event.$emit('loader:show', true);
		let token = await $session.get('token');

		if (!token) {
			Event.$emit('token:not-found', true);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule('my_loan');
	},
	created() {
		utils.registerModule('my_loan', my_loan, this.$store);
	},
	components: {
		Advert: () => import('../templates/ads/advert.vue'),
		ViewLoan: () => import('./view-my-loan.vue'),
		scrollbar: VueScrollbar,
	},
	data() {
		return {
			moment,
			utils,
		};
	},
	computed: {
		...mapGetters(['loading', 'my_loans']),
	},
	methods: {
		...mapActions(['viewLoan', 'fetchData']),
		async openLoan() {
			let account_number = await $session.get('selected_loan_page');

			if (account_number) {
				console.log(account_number);
				await this.viewLoan({
					account_number,
				});
				await $session.remove('selected_loan_page');
			}
		},
	},
	async mounted() {
		utils.registerModule('my_loan', my_loan, this.$store);
		await this.openLoan();
		await this.$store.dispatch('fetchData', this.$router);
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.school-loans {
	.scroll-content {
		height: calc(100vh - 230px);
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}

	.invoice-box {
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}

		.bolder-text {
			font-size: 13px;
			font-weight: 600;
		}
		.date-box {
			margin: -1px 15px 0 0;
			width: 100%;

			.status {
				font-size: 11px;
				text-align: right;
			}
			.txt {
				font-size: 13px;
				margin: 4px 5px 15px 0;
			}

			.month,
			.year {
				color: @grey;
				font-size: 14px;
				font-weight: 600;
				line-height: 12px;
				margin: 8px 5px;
			}

			.date {
				font-size: 14px;
				font-family: var(--font-bold);
				color: var(--text-color);
				margin: 4px 0 2px 5px;
			}
		}

		.name-box {
			.insurance {
				font-size: 17px;
				color: var(--text-color);
				font-family: var(--font-bold);
				line-height: 15px;
			}

			.txt {
				font-weight: 600;
				color: @grey;
				font-size: 14px;
			}
		}

		.categories {
			margin: 10px 0 0 0;

			.category:last-child {
				.circle {
					display: none;
				}
			}

			.name {
				font-weight: 600;
				color: #9c7bfc;
				font-size: 13px;
			}

			.circle {
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background: #9c7bfc;
				margin: 11px 10px 0 10px;
			}
		}

		.price-box {
			.price {
				font-size: 20px;
				line-height: 15px;
				font-family: var(--font-bold);
				margin: 5px 0 0 0;

				.point {
					font-size: 11px;
				}
			}

			.txt {
				font-weight: 600;
				color: @grey;
			}
		}
	}
}
</style>
